import { STATUS, ISSUE_ACTION } from "../constant";

const initState = {
  isApiLoading: null,
  issueListDownLoading: false,
  issueListDownLoadUrl: null
};

export default (state = initState, action) => {
  switch (action.type) {
    case ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_START:
    case ISSUE_ACTION.POST_COMMENT_START:
    case ISSUE_ACTION.ISSUE_CLARIFICATION_START:
    case ISSUE_ACTION.ISSUE_GUEST_LIST_START:
    case ISSUE_ACTION.MARK_ISSUE_DUPLICATE_START:
      return { ...state, isApiLoading: STATUS.LOADING };

    case ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_FAILURE:
    case ISSUE_ACTION.POST_COMMENT_FAILURE:
    case ISSUE_ACTION.ISSUE_CLARIFICATION_FAILURE:
    case ISSUE_ACTION.ISSUE_GUEST_LIST_FAILURE:
    case ISSUE_ACTION.MARK_ISSUE_DUPLICATE_FAILURE:
      return { ...state, isApiLoading: STATUS.ERROR };

    case ISSUE_ACTION.ISSUE_ACTION_CHANGE_STATUS_SUCCESS:
    case ISSUE_ACTION.POST_COMMENT_SUCCESS:
    case ISSUE_ACTION.ISSUE_CLARIFICATION_SUCCESS:
    case ISSUE_ACTION.MARK_ISSUE_DUPLICATE_SUCCESS:
      return {
        ...state,
        isApiLoading: STATUS.SUCCESS
      };

    case ISSUE_ACTION.ISSUE_GUEST_LIST_SUCCESS:
      return {
        ...state,
        guestListData: action.payload,
        isApiLoading: STATUS.SUCCESS
      };

    case ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_START:
      return {
        ...state,
        issueListDownLoadUrl: null,
        issueListDownLoading: STATUS.LOADING
      };

    case ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        issueListDownLoadUrl: action.payload,
        issueListDownLoading: action.payload ? STATUS.SUCCESS : STATUS.LOADING
      };

    case ISSUE_ACTION.ISSUE_LIST_REPORT_DOWNLOAD_FAILURE:
      return {
        ...state,
        issueListDownLoadUrl: null,
        issueListDownLoading: STATUS.ERROR
      };

    case ISSUE_ACTION.CLEAR_ISSUE_LIST_REPORT_DOWNLOAD:
      return {
        ...state,
        issueListDownLoadUrl: null,
        issueListDownLoading: null
      };

    default:
      return state;
  }
};
